// extracted by mini-css-extract-plugin
export default {"page":"qj-z","cartModal":"rj-z","checkout":"sj-z","placeholder":"tj-z","account":"uj-z"};